import { v4 as uuidv4 } from "uuid";

export const getOutputGuid = (): string => {
  return `output-${uuidv4()}`;
};

export const getInputGuid = (): string => {
  return `input-${uuidv4()}`;
};
